import React from 'react';
import { Link } from 'react-router-dom';

const HeroSection = ({ 
  title, 
  subtitle, 
  secondaryButtonText, 
  secondaryButtonLink,
  backgroundImage 
}) => {
  return (
    <section 
      className="relative h-[600px] bg-cover bg-center" 
      style={{
        backgroundImage: `linear-gradient(rgba(251, 146, 60, 0.3), rgba(251, 146, 60, 0.3)), url('${backgroundImage}')`
      }}
    >
      <div className="absolute inset-0 bg-gradient-to-r from-orange-900/40 to-red-900/40"></div>
      <div className="relative container mx-auto px-4 h-full flex items-center">
        <div className="max-w-3xl text-white">
          <h1 className="text-4xl md:text-6xl font-bold mb-6 leading-tight">
            {title}
          </h1>
          <p className="text-xl md:text-2xl mb-8 text-orange-100">
            {subtitle}
          </p>
          <div className="flex flex-col sm:flex-row gap-4">
            <Link 
              to={secondaryButtonLink} 
              className="bg-gradient-to-r from-orange-500 to-red-500 text-white px-4 sm:px-6 md:px-8 py-3 sm:py-4 rounded-full font-semibold text-sm sm:text-base md:text-lg hover:from-orange-600 hover:to-red-600 transition-all transform hover:scale-105 shadow-xl text-center"
            >
              {secondaryButtonText}
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
